
  import { getProductFromPath } from '@/scripts/utils';
  export default {
    middleware: ['products/cover-types', 'jumbotron', 'breadcrumbs', 'meta-tags'],
    meta: {
      category: 'insurance',
      disableBreadcrumb: true,
      product: 'life-insurance',
      searchPath: 'protection/life_insurance_searches'
    },
    computed: {
      coverType () {
        return this.$store.getters['products/getCoverType'];
      },
      coverTypeProduct () {
        return this.coverType.product ? this.coverType.product : null;
      }
    },
    created () {
      if (this.coverTypeProduct === null) return;

      this.$store.commit('providers/clearCurrent');
      this.$store.commit('search/reset', { type: 'lifeInsurance' });
      this.$cookies.remove(`bonkers-ie-${this.coverTypeProduct}-capture-point`);
      this.$cookies.remove(`bonkers-ie-${this.coverTypeProduct}-search`);
      if (this.coverType.product.includes('income')) {
        this.$store.commit('search/set', {life1: 50000});
      }
    },
    mounted () {
      const product = getProductFromPath(this.$router.currentRoute.path);
      this.$store.dispatch('matomo/trackIndexPageViewed', {name: `${product} index page viewed`});
    }
  };
